import { EventEmitter, Injectable, Input, Output } from '@angular/core';
import { OnDestroyMixin } from '@w11k/ngx-componentdestroyed';
import { PartialFormField } from '../form-fields/form-field.types';
import unformat from 'accounting-js/lib/unformat.js';
import get from 'lodash-es/get';

export interface EditableInterfaceComponent {
  model: any;
  fieldDef: any;
  data: any;
  readonly: boolean;
  showEmptyHolder?: boolean;
  editMode?: boolean;
  update: any;
  meta: { origin: string };
  showRecordActions?: boolean;
  onEndEditing?: EventEmitter<void>;
  fieldMask?: (fieldValue?: string) => string;
}

@Injectable()
export abstract class EditableComponent extends OnDestroyMixin implements EditableInterfaceComponent {
  showTip: string;
  isNestedField: boolean = false;

  @Input() model: any;
  @Input() fieldDef: any;
  @Input() data: any;
  @Input() readonly = false;
  @Input() showEmptyHolder = false;
  @Input() editMode = false;
  @Input() showRecordActions = true;
  @Input() meta: { origin: string };
  @Input() fieldMask?: (fieldValue?: string) => string;
  @Output() update: EventEmitter<PartialFormField> = new EventEmitter();
  @Output() onEndEditing: EventEmitter<void> = new EventEmitter<void>();

  get isDisabled(): boolean {
    return this.readonly || this.fieldDef?.locked;
  }

  ngOnInit(): void {
    this.showTip = this.fieldDef.description || this.fieldDef.meta?.calc_code;
    this.isNestedField = this.fieldDef.name.includes('.');

    if (['number', 'decimal'].includes(this.fieldDef.type)) {
      this.showTip = this.showTip || 'use formula e.g. =2+2';
    }
  }

  protected getValue(): any {
    if (this.fieldDef.meta?.value_hidden) {
      return 'REDACTED';
    }
    return this.isNestedField
      ? this.getLinkedFieldValue(this.model, this.fieldDef.name)
      : this.model[this.fieldDef.name];
  }

  protected removeFormatting(value: string): null | string | number {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    return unformat(value);
  }

  protected getLinkedFieldValue(object: any, fieldName: string): { label: string; [key: string]: any }[] {
    const firstLevel = fieldName.split('.')[0];
    const propLevel = fieldName.split('.')[1];
    if (Array.isArray(object[firstLevel])) {
      return object[firstLevel].map((item) => ({ label: item[propLevel], ...item }));
    }

    const label = get(object, fieldName);
    if (label) {
      return [{ label: get(object, fieldName), ...object[firstLevel] }];
    }
  }
}
